import {
  ApolloClient,
  InMemoryCache,
  HttpLink,
  concat,
  split,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { getMainDefinition } from "@apollo/client/utilities";
import { WebSocketLink } from "@apollo/client/link/ws";
import { fire } from "./firebase";

const httpLink = new HttpLink({
  uri: "https://tap-backend-u6w4.onrender.com/graphql",
});

const wsLink = new WebSocketLink({
  uri: "wss://tap-backend-u6w4.onrender.com/graphql",
  options: {
    reconnect: false,
  },
});

const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === "OperationDefinition" &&
      definition.operation === "subscription"
    );
  },
  wsLink,
  httpLink
);

const asyncAuthLink = setContext(async () => {
  return {
    headers: {
      Authorization: `Seeker ${await fire.auth().currentUser?.getIdToken()}`,
    },
  };
});

const Client = new ApolloClient({
  cache: new InMemoryCache({
    addTypename: false,
  }),
  link: concat(asyncAuthLink, splitLink),
});

export default Client;
